import { AfterViewInit, ChangeDetectionStrategy, Component, computed, ElementRef, inject, viewChild } from "@angular/core";
import { CommonButtonRowWidget, CommonSelectFieldWidget, CommonTextFieldWidget, HOURS_ET, STANDARD_FOUR_TIME_ZONE_ID, UtilityService } from "@eforall/common";
import { AccTeamUpdateValues } from "@interfaces";
import { DomainDataService } from "../../../../../services";
import { ReadonlyAccessWidget } from "../../../readonly-access/readonly-access.widget";
import { AccTeamDialogDataService } from "../acc-team-dialog-data.service";
import { AccTeamFormValues, DetailsPartForm } from "./details-part.form";

@Component({
	selector: 'acc-team-details-part',
	standalone: true,
	imports: [
		CommonTextFieldWidget,
		CommonButtonRowWidget,
		CommonSelectFieldWidget,
		ReadonlyAccessWidget
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './details.part.html'
})
export class AccTeamDetailsPart implements AfterViewInit {

	private readonly util = inject(UtilityService);
	private readonly domainDataService = inject(DomainDataService);
	public readonly dialogDataService = inject(AccTeamDialogDataService);

	public readonly form = new DetailsPartForm();
	public saveBtn = viewChild.required<ElementRef<HTMLButtonElement>>('saveBtn');

	public isTimeSelectionValid = true;

	public teamDetails = computed(() => {
		const team = this.dialogDataService.dialogData();
		if (!team) return undefined;

		return {
			...team,
			meetingTime: team.meetingStartSlot !== undefined && team.meetingStartSlot !== null ? this.util.date.formatAccMeetingSlot(team.meetingStartSlot, STANDARD_FOUR_TIME_ZONE_ID.Eastern,).acceleratorDisplayTime : 'N/A',
			formattedOverlappingMeetingSlots: team.overlappingMeetings ? this.util.date.formatMeetingSlots(team.overlappingMeetings.selectedMeetingSlots, STANDARD_FOUR_TIME_ZONE_ID.Eastern) : ['N/A'],
			formattedCreatedDate: this.util.date.formatUTC(team.createdUTC, 'MMM D, YYYY', 'H:MM AM EST', 'en-US'),
			formattedUpdatedDate: this.util.date.formatUTC(team.updatedUTC, 'MMM D, YYYY', 'H:MM AM EST', 'en-US')
		};
	});

	ngAfterViewInit() {
		this.form.form.setSubmitButton(this.saveBtn(), async (values: AccTeamFormValues, changed: string[]) => {

			if (changed.length === 0) return;

			// One provided but not the other(XOR) - invalid
			// valid if both are provided or both are not provided
			if (!!values.dayIndex !== !!values.startTimeIndex) {
				this.isTimeSelectionValid = false;
				return;
			}

			let meetingStartSlot = undefined;

			// Values are 0-118 (stored in ET)
			// 0 - 16 = Mon 6am - 10pm (Monday is dayIndex 0)
			// 101 - 118 = Sun 6am - 10pm (Sunday is dayIndex 6)
			if (values.dayIndex && values.startTimeIndex) {
				// Both provided - calculate slot (0-118, stored in ET)
				meetingStartSlot = (Number(values.dayIndex) * HOURS_ET.length) + (Number(values.startTimeIndex));
				this.isTimeSelectionValid = true;
			}

			const changedValues: AccTeamUpdateValues = {
				name: values.name,
				googleMeetCode: this.util.url.extractMeetCode(values.googleMeetCode),
				meetingStartSlot,
				meetingDetails: values.meetingDetails,
			};

			await this.dialogDataService.updateTeamDetails(changedValues);
		});
	}


	openTeamMeeting(code: string) {
		const url = this.util.url.getGoogleMeetLink(code);
		window.open(url, '_blank');
	}

	revertChanges() {
		this.form.form.resetAll();
		this.isTimeSelectionValid = true;
	}
}